import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

export interface FinanceInvoiceDeleteDetails {
  TotalLoanAmount: number;
  PrevReceiptNo: number;
  ReceiptDate: string;
}

@Injectable({
  providedIn: "root",
})
export class FinanceVehicleReceiptService {
  constructor(private http: HttpUtilService) {}

  getBankList(): Observable<any> {
    return this.http.get("FinanceVehicleReceiptService.asmx/GetBankList");
  }

  getFinanceVehicle(finCompCode: string, searchOption: string, searchText: string): Observable<any> {
    const params = new URLSearchParams({
      finCompCode: JSON.stringify(finCompCode),
      searchOption: JSON.stringify(searchOption),
      searchText: JSON.stringify(searchText),
    }).toString();
    return this.http.get(`FinanceVehicleReceiptService.asmx/GetFinanceVehicle?${params}`);
  }

  getLastReceipt(): Observable<any> {
    return this.http.get("FinanceVehicleReceiptService.asmx/GetLastReceipt");
  }

  saveFinanceInvoice(payload: any): Observable<any> {
    return this.http.post("FinanceVehicleReceiptService.asmx/SaveFinanceInvoice", payload);
  }

  deleteInvoice(details: FinanceInvoiceDeleteDetails): Observable<any> {
    return this.http.post("FinanceVehicleReceiptService.asmx/DeleteInvoice", {
      invNo: details,
    });
  }

  printByReceiptNo(receiptNo: string): Observable<any> {
    return this.http.post("FinanceVehicleReceiptService.asmx/PrintByReceiptNo", { receiptno: receiptNo });
  }
}
